export default __webpack_public_path__ + "/dist/images/image4.ccc05ac385504f0ccb41f51570aa703c.jpg";